module.exports = __webpack_public_path__ + "static/media/roma-square.48451b41.jpg";